import { IHKRDashboardDataVM } from '../../models/response/IHKRDashboardDataResponse';
const initialHKRDashboardDataState: IHKRDashboardDataVM = {
    HKRTableData: [],
    SavedColumn:"",
    PagingDetails: {
        TotalRecords: 0,
        TotalPages: 0,
        CurrentPage: 0,
        PageSize: 0
    }
};

export default initialHKRDashboardDataState;
